import { Instance } from 'mobx-state-tree'
import { SetupIntentResponseModelBase } from './SetupIntentResponseModel.base'

/* The TypeScript type of an instance of SetupIntentResponseModel */
export interface SetupIntentResponseModelType extends Instance<typeof SetupIntentResponseModel.Type> {}

/* A graphql query fragment builders for SetupIntentResponseModel */
export {
  selectFromSetupIntentResponse,
  setupIntentResponseModelPrimitives,
  SetupIntentResponseModelSelector
} from './SetupIntentResponseModel.base'

/**
 * SetupIntentResponseModel
 */
export const SetupIntentResponseModel = SetupIntentResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
